import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

interface TabPagesProps {
  tabHeadings: (string | React.ReactNode)[];
  tabFunctions: (() => void)[];
  tabActive: number;
}

export default function TabPages(props: TabPagesProps) {
  const [value, setValue] = React.useState<number>(
    typeof props.tabActive === "number" ? props.tabActive : 0
  );

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    if (props.tabFunctions[newValue]) {
      props.tabFunctions[newValue]();
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        // zIndex: "5",
        zIndex: 10,
        position: "relative",
      }}
    >
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          width: "100%",
          marginBottom: "20px",
          // zIndex: "5",
          zIndex: 10,
          position: "relative",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="tab pages"
          centered={false}
          variant="fullWidth"
          textColor="inherit"
          TabIndicatorProps={{
            style: {
              backgroundColor: "#fbcd02",
              zIndex: "9999",
            },
          }}
          sx={{
            display: "flex",
            "& .MuiTab-root": {
              flexGrow: 1,
              textAlign: "center",
              minWidth: 0,
              fontSize: isSmallScreen ? "0.9rem" : "1rem",
              padding: "10px 15px",
              marginRight: isSmallScreen ? "5px" : "15px",
              borderRadius: "5px",
              fontWeight: "bold",
              color: "white",

              // zIndex: "9999",
            },
          }}
        >
          {props.tabHeadings.map((heading, index) => (
            <Tab
              key={index}
              label={heading}
              {...a11yProps(index)}
              sx={{ color: "white" }}
            />
          ))}
        </Tabs>
      </Box>
    </Box>
  );
}
